import React from 'react';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/JSErrorBoundary.tsx';
import { GlobalAiRovoButton } from './GlobalAiRovoButton.tsx';

export const GlobalAiRovoButtonWithBoundary = (): React.JSX.Element | null => {
	return (
		<JSErrorBoundary
			fallback="unmount"
			id="global-ai-rovo-button"
			packageName="ai-rovo-button"
			teamName="reverie"
		>
			<GlobalAiRovoButton />
		</JSErrorBoundary>
	);
};
